import { useContext } from 'react';
import { CustomThemeContext } from '../../../../context/theme/custom-theme-context';
import { AuthBranding, resolveAuthBranding } from './auth-branding';

/**
 * Resolve the active auth branding (greens, logo, wash, product name, focus
 * ring) from the partner theme context. Shared by every auth/onboarding screen
 * so they all brand consistently.
 */
export const useAuthBranding = (): AuthBranding => {
  const customThemeContext = useContext(CustomThemeContext);
  return resolveAuthBranding(
    customThemeContext.theme,
    customThemeContext.partnerName,
    customThemeContext.logoUrl,
    customThemeContext.hideSignUpButton,
    {
      headline: customThemeContext.partnerLoginHeadline,
      subheadline: customThemeContext.partnerLoginSubheadline,
      eyebrow: customThemeContext.partnerLoginEyebrow,
      reversedLogoUrl: customThemeContext.partnerReversedLogoFilepath,
    },
  );
};
